<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <app-header [cartCount]="cartCount"></app-header>

  <!-- Page Content -->
  <section class="max-w-5xl mx-auto px-4 py-10">
    <div class="bg-white rounded-2xl shadow-sm p-6 md:p-10">

      <h1 class="text-2xl md:text-3xl font-semibold text-gray-800 mb-6">
        Terms & Conditions
      </h1>

      <p class="text-sm text-gray-600 mb-8 leading-relaxed">
        Welcome to <span class="font-medium text-gray-800">capitalfood.in</span>.
        By accessing or using our website, you agree to comply with and be bound by
        the following Terms & Conditions. Please read them carefully before using
        our services.
      </p>

      <div class="space-y-8 text-sm text-gray-700 leading-relaxed">

        <!-- 1 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">1. Acceptance of Terms</h2>
          <p>
            By using capitalfood.in, you acknowledge that you have read, understood,
            and agreed to these Terms & Conditions. If you do not agree, please
            discontinue using the website.
          </p>
        </div>

        <!-- 2 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">2. About capitalfood.in</h2>
          <p>
            capitalfood.in is a food service platform offering multiple cuisines and
            operating as a direct partner with Swiggy and Zomato for food delivery.
            We also cater to bulk and large-quantity orders for individuals, offices,
            and events.
          </p>
        </div>

        <!-- 3 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">3. Service Availability</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Operational Days: Monday to Saturday</li>
            <li>Operational Hours: 11:00 AM to 06:00 PM</li>
            <li>Services are unavailable on Sundays or outside operating hours</li>
            <li>Orders placed outside service hours may not be processed</li>
          </ul>
        </div>

        <!-- 4 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">4. Ordering & Delivery</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Standard deliveries are fulfilled through Swiggy and Zomato</li>
            <li>Delivery time, rider availability, and tracking are managed by the delivery partners</li>
            <li>
              capitalfood.in is not responsible for delays caused by third-party
              delivery partners, weather, traffic, or force majeure events
            </li>
          </ul>
        </div>

        <!-- 5 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">5. Bulk & Large-Quantity Orders</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Bulk orders must be placed in advance and are subject to confirmation</li>
            <li>Special preparation time, pricing, packaging, and delivery conditions may apply</li>
            <li>Once confirmed, bulk orders cannot be cancelled or modified</li>
          </ul>
        </div>

        <!-- 6 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">6. Pricing & Payment</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Prices may vary based on cuisine, order size, and delivery partner</li>
            <li>Final pricing is subject to confirmation at the time of order</li>
            <li>Payments are processed securely via authorized payment gateways or partner platforms</li>
          </ul>
        </div>

        <!-- 7 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">7. Use of Cookies & Data</h2>
          <p>
            capitalfood.in uses cookies to store user preferences, improve website
            functionality, and enhance user experience. By using our website, you
            consent to our cookie usage as outlined in our Privacy Policy.
          </p>
          <p class="mt-1">
            We do not sell or misuse personal data.
          </p>
        </div>

        <!-- 8 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">8. User Responsibilities</h2>
          <p>Users agree to:</p>
          <ul class="list-disc pl-5 space-y-1 mt-1">
            <li>Provide accurate and complete information</li>
            <li>Use the website for lawful purposes only</li>
            <li>Not misuse, disrupt, or damage the website or services</li>
          </ul>
          <p class="mt-1">
            capitalfood.in reserves the right to restrict or terminate access if misuse is detected.
          </p>
        </div>

        <!-- 9 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">9. Food Quality & Consumption</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>All food is prepared following hygiene and quality standards</li>
            <li>Customers are advised to consume food promptly after delivery</li>
            <li>
              capitalfood.in is not liable for quality issues arising from delayed
              consumption or improper storage
            </li>
          </ul>
        </div>

        <!-- 10 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">10. Cancellation & Refunds</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Orders once accepted and prepared are non-cancellable</li>
            <li>Refunds, if applicable, are subject to delivery partner policies</li>
            <li>Issues must be reported within a reasonable timeframe after delivery</li>
          </ul>
        </div>

        <!-- 11 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">11. Intellectual Property</h2>
          <p>
            All content on capitalfood.in, including logos, text, images, and design,
            is the intellectual property of capitalfood.in and may not be copied,
            reused, or distributed without prior written consent.
          </p>
        </div>

        <!-- 12 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">12. Limitation of Liability</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Indirect or consequential damages</li>
            <li>Service interruptions due to technical issues</li>
            <li>Delays or failures caused by third-party delivery partners</li>
          </ul>
        </div>

        <!-- 13 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">13. Modifications to Terms</h2>
          <p>
            capitalfood.in reserves the right to update or modify these Terms & Conditions
            at any time. Changes will be effective immediately upon posting on the website.
          </p>
        </div>

        <!-- 14 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">14. Governing Law</h2>
          <p>
            These Terms & Conditions shall be governed by and construed in accordance
            with the laws of India.
          </p>
        </div>

        <!-- 15 -->
        <div>
          <h2 class="font-semibold text-gray-800 mb-2">15. Contact Information</h2>
          <p>
            For any questions or concerns regarding these Terms & Conditions,
            please contact us through the official communication channels listed
            on capitalfood.in.
          </p>
        </div>

      </div>
    </div>
  </section>

  <!-- Footer -->
  <app-footer></app-footer>
</div>
